export default __webpack_public_path__ + "static/typson-4350d2f655e1ce399d10b4b807ce3905.png";